import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SupplyEnquiries } from '../../models/supply-enquiries';
import { GetSupplyEnquiriesByPkService } from '../../services/get-supply-enquiries-by-pk.service';

@Component({
  selector: 'app-my-enquiries-details',
  templateUrl: './my-enquiries-details.component.html',
  styleUrls: ['./my-enquiries-details.component.scss']
})
export class MyEnquiriesDetailsComponent implements OnInit {
/* --------------------------------- Fields --------------------------------- */
oldSupplyEnquiries: SupplyEnquiries;
/* ------------------------------- Constructor ------------------------------ */
  constructor(
    private route: ActivatedRoute,
    private matDialog: MatDialog,
    private getSupplyEnquiriesByPkService: GetSupplyEnquiriesByPkService
    ) { }
/* ---------------------------- Life cycle hooks ---------------------------- */
  ngOnInit(): void {
    if(this.route.snapshot.data && this.route.snapshot.data.oldSupplyEnquiries){
      this.oldSupplyEnquiries = this.route.snapshot.data.oldSupplyEnquiries;
    }
  }

  getLatestData(){
    this.getSupplyEnquiriesByPkService.getSupplyEnquiriesByPk(this.oldSupplyEnquiries.id).subscribe(data=>{
      this.oldSupplyEnquiries = data;
    })
  }
}

